export default __webpack_public_path__ + "static/6661-7632837f82c712cce87c14856e9ac6e4.jpg";